import React, { useEffect, useRef } from 'react';

import amplitude from 'amplitude-js';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import ServerSideDisclaimer from 'apps/auth/components/send/disclaimers/ServerSideDisclaimer';
import { ERROR_SCREEN_TRY_AGAIN_SHOWN, ERROR_SCREEN_TRY_AGAIN_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { ERROR, ERROR_TYPE, PAYMENT_COUNTRY, PAYMENT_CURRENCY, PAYOUT_COUNTRY, PAYOUT_CURRENCY } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { AUTH_SEND_MAIN_LINK, AUTH_SEND_REPEAT } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { logInfo } from 'apps/auth/helpers/clientLogger';
import { useAuth, useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const SeamlessRetry = (props) => {
    const popupRef = useRef(null);
    const { headerTitle, statusText, moreDetailsTitle, statusCancelTitle, notNowButton } = usePageMessages();
    const { disclaimerFromServerSide, cheque, statusBean } = useExtra();
    const { countryId } = useAuth();

    useEffect(() => {
        amplitude.getInstance().logEvent(ERROR_SCREEN_TRY_AGAIN_SHOWN, { [ERROR]: statusBean?.errorCode, [ERROR_TYPE]: statusBean?.message });
    }, []);

    const onCloseClick = (e) => {
        e?.preventDefault();
        props.modalRef?.current?.close();
    };

    return (
        <>
            <InfoPage
                dataTestId={props.dataTestId}
                animatedIconFail
                headerText={headerTitle}
                topButtonCaption={notNowButton}
                secondaryText={<DangerouslyHtml dangerouslyHtml={statusText} />}
                buttonRowCaption={disclaimerFromServerSide ? moreDetailsTitle : null}
                buttonRowOnClick={(e) => {
                    e.preventDefault();
                    props.modalRef.current?.open(
                        <ServerSideDisclaimer
                            title={disclaimerFromServerSide.title}
                            content={disclaimerFromServerSide}
                            onButtonClick={onCloseClick}
                            userCountry={countryId}
                            onCloseClick={onCloseClick}
                        />,
                    );
                }}
                topButtonOnClick={(e) => {
                    e?.preventDefault();
                    props.toggleSpinner(true);
                    apiFetchData(`/auth/send/incomplete/force/create.action?paymentId=${statusBean?.id}`)
                        .then(() => {
                            window.location.replace(AUTH_SEND_MAIN_LINK);
                        })
                        .catch((e) => {
                            logInfo(e);
                            window.location.replace(AUTH_SEND_MAIN_LINK);
                        });
                }}
                primaryButtonCaption={statusCancelTitle}
                primaryButtonOnClick={(e) => {
                    e?.preventDefault();
                    amplitude.getInstance().logEvent(ERROR_SCREEN_TRY_AGAIN_CLICKED, {
                        [PAYOUT_COUNTRY]: cheque?.toCountry?.nameEn,
                        [PAYMENT_COUNTRY]: cheque?.fromCountry?.nameEn,
                        [PAYOUT_CURRENCY]: cheque?.amountToCurrency,
                        [PAYMENT_CURRENCY]: cheque?.amountFromCurrency,
                    });
                    props.toggleSpinner(true);
                    window.location.replace(
                        cheque?.recipientType
                            ? `${AUTH_SEND_REPEAT}?repeatId=${statusBean?.id}&type=${cheque?.recipientType}&forceShowPaymentMethods=true`
                            : AUTH_SEND_MAIN_LINK,
                    );
                }}
            />
            <PopupNew ref={popupRef} />
        </>
    );
};

export default SeamlessRetry;
